export enum UserClaim {
  Claim_Admin = 'Claim_Admin',
  Claim_User_Create = 'Claim_User_Create',
  Claim_User_Review = 'Claim_User_Review',
  Claim_User_Revoke = 'Claim_User_Revoke',
  Claim_Local_User_Create = 'Claim_Local_User_Create',
  Claim_Local_User_Review = 'Claim_Local_User_Review',
  Claim_Local_User_Revoke = 'Claim_Local_User_Revoke',
  Claim_Report_Create = 'Claim_Report_Create',
  Claim_Report_Review = 'Claim_Report_Review',
  Claim_Notification_Create = 'Claim_Notification_Create',
  Claim_Registration_Edit = 'Claim_Registration_Edit',
  Claim_Report_Approve = 'Claim_Report_Approve',
  Claim_Registry_Review = 'Claim_Registry_Review',
  Claim_Registry_Edit = 'Claim_Registry_Edit',
  Claim_Automatic_Processing_Code_Lock = 'Claim_Automatic_Processing_Code_Lock',
  Claim_Explicit_Hierarchy_Create = 'Claim_Explicit_Hierarchy_Create',
  Claim_Explicit_Hierarchy_Review = 'Claim_Explicit_Hierarchy_Review',
  Claim_Report_Type_Period_Lock = 'Claim_Report_Type_Period_Lock',
  Claim_Report_Correction = 'Claim_Report_Correction',
  Claim_Report_Review_All = 'Claim_Report_Review_All',
  Claim_Report_Economy_Review_All = 'Claim_Report_Economy_Review_All',
  Claim_Report_Type_Review = 'Claim_Report_Type_Review',
  Claim_Automatic_Processing_Code_Review = 'Claim_Automatic_Processing_Code_Review',
  Claim_Report_Note_Restriction = 'Claim_Report_Note_Restriction',
  Claim_Report_Note_Create = 'Claim_Report_Note_Create',
  Claim_Empty = 'Claim_Empty',
  Claim_Report_Type_Schedule_Create = 'Claim_Report_Type_Schedule_Create',
  Claim_Report_Type_Period_Organization_Create = 'Claim_Report_Type_Period_Organization_Create',
  Claim_Report_Helper_Create = 'Claim_Report_Helper_Create'
}
